import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import TrialRedirectButton from './tx-120/TrialRedirectButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ActivationSuccessFooter = ({
  ctaText,
  showTrialLoadingState,
  onSuccess = () => {},
  upgradeData
}) => {
  return /*#__PURE__*/_jsx(UIDialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(UIList, {
      firstChildClassName: "m-bottom-3",
      style: {
        maxWidth: '350px'
      },
      children: showTrialLoadingState ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        showLabel: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.loadingLabel"
        })
      }) : /*#__PURE__*/_jsx(TrialRedirectButton, {
        block: true,
        use: "primary",
        onClick: onSuccess,
        buttonText: ctaText,
        upgradeData: upgradeData
      })
    })
  });
};
export default ActivationSuccessFooter;